import '../../vendor/spatie/laravel-comments-livewire/resources/js/comments.js'

import { init } from "shareon"
init()
